import { render, staticRenderFns } from "./HistoryLogs.vue?vue&type=template&id=b76d2a9e&"
import script from "./HistoryLogs.vue?vue&type=script&lang=js&"
export * from "./HistoryLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports